import React, { useState } from "react";
import { Form } from "react-bootstrap";
import NextBtn from "./nextbutton";

const StepThird = ({ handleStepChange }) => {
  const [active, setActive] = useState(false);
  const handleclick = () => {
    setActive(!active);
  };

  return (
    <div className='resource-step-content'>
      <div className='resource-content'>
        <div className='resource-step-heading'>
          <h4>What’s your project budget?</h4>
          <p>Please select the project budget range you have in mind..</p>
        </div>
        <div className='resource-budget-content'>
          <div className='resource-budget-box'>
            <div className='resource-radio'>
              <input type='radio' />
            </div>
            <span>$5.000 - $10.000</span>
          </div>
          <div className={`resource-budget-box ${active ? `active` : ``}`}>
            <div className='resource-radio' onClick={handleclick}>
              <input type='radio' />
            </div>
            <span>$10.000 - $20.000</span>
          </div>
          <div className='resource-budget-box'>
            <div className='resource-radio'>
              <input type='radio' />
            </div>
            <span>$20.000 - $50.000</span>
          </div>
          <div className='resource-budget-box'>
            <div className='resource-radio'>
              <input type='radio' />
            </div>
            <span>Please enter amount</span>
          </div>
        </div>
        <Form onSubmit={() => handleStepChange(1, 25)}>
          <div className='resource-form'>
            <Form.Group className='resource-dev-input'>
              <label>Amount</label>
              <div className='resource-input'>
                <Form.Control type='text' placeholder='$ 0' />
              </div>
            </Form.Group>
            <Form.Group className='resource-dev-input'>
              <label>Hour</label>
              <div className='resource-input'>
                <Form.Control type='text' placeholder='0 hr' />
              </div>
            </Form.Group>
          </div>
          <NextBtn handleStepChange={handleStepChange} />
        </Form>


      </div>
    </div>
  );
};

export default StepThird;
